import { actionTypes } from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STRIPE_ONBOARDING_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.STRIPE_ONBOARDING_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.STRIPE_ONBOARDING_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.STRIPE_ONBOARDING_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.STRIPE_ONBOARDING_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
